import React from "react";
import { useNavigate } from "react-router-dom";

function HelperInfo() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-16 px-6">
      <div className="max-w-5xl mx-auto text-center">

        {/* Title */}
        <h1 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
          Become a Service Partner
        </h1>

        <p className="text-lg text-gray-600 mb-12">
          Join AutoHelper AI and start earning by providing your services.
          Flexible timing, instant bookings and AI based smart assignment.
        </p>

        {/* Benefits Section */}
        <div className="grid md:grid-cols-3 gap-8 mb-12">

          <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition">
            <h3 className="text-xl font-semibold mb-3">Flexible Work</h3>
            <p className="text-gray-600">
              Work anytime. Set your availability and accept bookings.
            </p>
          </div>

          <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition">
            <h3 className="text-xl font-semibold mb-3">Instant Requests</h3>
            <p className="text-gray-600">
              Receive real-time service requests from nearby users.
            </p>
          </div>

          <div className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition">
            <h3 className="text-xl font-semibold mb-3">Secure Payments</h3>
            <p className="text-gray-600">
              Get secure and fast payments directly in your account.
            </p>
          </div>

        </div>

        {/* Buttons */}
        <div className="flex justify-center gap-6">

          {/* 🔥 Register Button — UPDATED */}
          <button
            onClick={() => navigate("/register-helper")}
            className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-3 rounded-full font-semibold hover:scale-105 transition"
          >
            Register as Helper
          </button>

          {/* Login Button */}
          <button
            onClick={() => navigate("/login")}
            className="border border-blue-600 text-blue-600 px-8 py-3 rounded-full font-semibold hover:bg-blue-50 transition"
          >
            Login as Helper
          </button>

        </div>

      </div>
    </div>
  );
}

export default HelperInfo;
